import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { map, catchError, retry } from 'rxjs/operators';
import { Store } from '../models/store';

@Injectable({
	providedIn: 'root'
})

export class StoreService {

	constructor(private http: HttpClient, private authService: AuthService) { }

	getStores(): Promise<Observable<Store[]>> {
		return this.authService.GetDefaultHeaders().then((contentHeaders: HttpHeaders) => {
			
			let storeApiUrl = ConfigService.APP_API_ENDPOINT + "store/v1";
			
			// make http get request
			return this.http.get<Store[]>(storeApiUrl, { headers: contentHeaders }).pipe(
				retry(3), // retry a failed request up to 3 times
      			catchError(this.handleError), // then handle the error
				map(res => res['objectdata']) // on success, data is within 'objectdata' in json
			);
		});
	}

	private handleError(error: HttpErrorResponse) {
		if (error.error instanceof ErrorEvent) {
		  // A client-side or network error occurred. Handle it accordingly.
		  console.error('An error occurred:', error.error.message);
		} else {
		  // The backend returned an unsuccessful response code.
		  // The response body may contain clues as to what went wrong,
		  console.error(
			`Backend returned code ${error.status}, ` +
			`body was: ${error.error}`);

			// return an observable with a user-facing error message
			return throwError('Unable to fetch Stores; Error code ' + error.status + ' (' + error.statusText + ')');
		}
		// return an observable with a user-facing error message
		return throwError(
		  'Unable to fetch Stores; please try again later.');
	};
}
